import { c as _c } from "react/compiler-runtime";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { Box } from "@mui-wrapper";
import { grey, TeamIcon } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { withEllipsis } from "@styles/common-styles";
import { getMailToLink } from "@utils/email-utils";
import { getPendingUserIcon, getPrettyName, getUserInitials } from "@utils/user-utils";
/** Width in pixels for the name and email wrapper, needed to show ellipsis */
const NAME_EMAIL_WRAPPER_WIDTH = "165px";

/**
 * Component that shows the title of the menu when the user hovers over a member to see a quick
 * overlook about the user and open the profile page.
 * Includes the avatar, name and email.
 */
export function UserMoreInfoMenuTitle(t0) {
  const $ = _c(16);
  const {
    member,
    isCurrentUser
  } = t0;
  if (!member) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "83px",
      width: "100%",
      backgroundColor: "surfaces.secondary",
      display: "flex",
      alignItems: "center",
      padding: "11px"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      marginRight: "16px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isCurrentUser || $[4] !== member) {
    t3 = <Box component="div" sx={t2}>{FaroCoreApiUtils.Member.isTeam(member) ? <SphereAvatar icon={<TeamIcon sx={{
        width: "20px",
        height: "20px"
      }} />} size="small" shouldHideWhiteRim={true} backgroundColor={grey[700]} /> : <SphereAvatar initials={getUserInitials(member)} src={member?.thumbnailUrl} icon={getPendingUserIcon(member, "large")} size="large" shouldUseSimplifiedAvatar={!isCurrentUser} shouldHideWhiteRim={true} />}</Box>;
    $[3] = isCurrentUser;
    $[4] = member;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== member) {
    t4 = FaroCoreApiUtils.Member.isMemberActive(member) && <Box component="div" sx={{
      fontSize: "12px",
      color: "text.primary",
      width: NAME_EMAIL_WRAPPER_WIDTH,
      ...withEllipsis
    }}><var>{getPrettyName(member)}</var></Box>;
    $[6] = member;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== member) {
    t5 = !FaroCoreApiUtils.Member.isTeam(member) && <Box component="div" sx={{
      fontSize: "10px"
    }}><var>{getMailToLink(member?.email ?? "", {
          color: "primary.main",
          display: "inline-block",
          width: NAME_EMAIL_WRAPPER_WIDTH,
          ...withEllipsis
        })}</var></Box>;
    $[8] = member;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Box component="div">{t4}{t5}</Box>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <Box component="div" sx={t1}>{t3}{t6}</Box>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}